<template>
  <!-- 物流查询 -->
  <div class="LogisticsInfo"
       v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 轮播图 -->
    <el-carousel height="430px"
                 arrow='never'
                 indicator-position='none'>
      <el-carousel-item v-for="item in adImage"
                        :key="item.title">
        <el-image :src="item.url"
                  fit="fill">
          <div slot="placeholder"
               class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 查询框 -->
    <div class="search_view">
      <div class="search_view_top">
        <el-input placeholder="请输入本公司生成的物流单号"
                  prefix-icon="el-icon-search"
                  v-model="logisticsNumber">
        </el-input>
        <el-button type="primary"
                   @click="getLogistics_info"
                   icon="el-icon-search">查询</el-button>
      </div>
      <div class="history_show">
        <div class="history_show_record">
          <div class="history_title">历史记录:</div>
          <el-tag :key="index"
                  v-for="(tag,index) in historyData"
                  closable
                  size="mini"
                  disable-transitions
                  @close="handleClose(tag)"
                  @click='clickHistory(tag)'>
            {{tag}}
          </el-tag>
        </div>
        <div class="history_show_btn">
          <el-link icon="el-icon-delete"
                   @click="emptyRecord"
                   :disabled='historyData.length<1'>清空记录</el-link>
        </div>
      </div>

    </div>
    <!-- 其他功能 -->
    <div class="other_view">
      <el-button class="other_view_item"
                 icon="el-icon-box"
                 @click="skipBusiness">商业件下单</el-button>
      <el-button class="other_view_item"
                 icon="el-icon-takeaway-box"
                 @click="skipConcentrated">集运件下单</el-button>
      <el-button class="other_view_item"
                 icon="el-icon-search"
                 @click="skipInquire">查询价格</el-button>
      <el-button class="other_view_item"
                 disabled
                 icon="el-icon-document">订单列表</el-button>

    </div>
    <!-- 物流信息 -->
    <div class="logistics_info">
      <el-timeline>
        <el-timeline-item :timestamp="item.zttime"
                          placement="top"
                          v-for="(item,index) in logisticsState"
                          :key="index"
                          :type='item.showType'>
          <el-card>
            <h4>{{item.zt}}</h4>
            <p>{{item.info}}</p>
          </el-card>
        </el-timeline-item>

      </el-timeline>
    </div>

  </div>
</template>

<script>
import common from '../assets/js/common'
import { apiAdImage, apiLogistics } from '@/request/api'
export default {
  data () {
    return {
      // ---------物流状态---------
      logisticsState: [],
      // ---------轮播图数据---------
      adImage: [],
      // ---------历史记录---------
      historyData: [],
      // ---------物流单号---------
      logisticsNumber: '',
      // ---------加载动画---------
      fullscreenLoading: false,
    }
  },
  methods: {
    //   --------- 查询报价 ---------
    skipInquire () {
      this.$router.push({
        name: this.not ? 'examinePrice' : 'Inquire'
      })
    },
    //   --------- 跳转集运下单 ---------
    skipConcentrated () {
      this.$router.push({
        name: 'Concentrated'
      })
    },
    //   --------- 跳转商业件 ---------
    skipBusiness () {
      this.$router.push({
        name: 'placeOrder'
      })
    },
    //   --------- 清空记录---------
    emptyRecord () {
      this.$confirm('此操作将永久清除记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.historyData = []
        this.setHistoryData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清除'
        });
      });

    },
    //   --------- 点击历史记录---------
    clickHistory (e) {
      this.logisticsNumber = e
      this.getLogistics_info()
    },
    //   --------- 删除物流记录---------
    handleClose (tag) {
      this.historyData.splice(this.historyData.indexOf(tag), 1);
      this.setHistoryData(this.historyData)
    },
    //   --------- 获取物流信息---------
    async getLogistics_info () {
      this.fullscreenLoading = true
      if (this.logisticsNumber == '') {
        this.$message.error('物流单号不能为空')
      } else if (this.logisticsNumber.length < 8) {
        this.$message.error('请输入正确的物流单号')
      } else {
        let res = await apiLogistics({
          wlnum: this.logisticsNumber
        })
        if (res.errno == 0) {
          this.logisticsState = res.ztlist
          for (const key in res.ztlist) {
            common.formatDate(res.ztlist[key].zttime, (y, m, d) => {
              res.ztlist[key].zttime = y + '/' + m + '/' + d
            })
            let s = res.ztlist[key].status
            if (s == -1 || s == -4 || s == -6 || s == -66 || s == -2) {
              res.ztlist[key].showType = 'danger'
            } else if (s == 12 || s == 13 || s == 14 || s == 15) {
              res.ztlist[key].showType = 'primary'
            } else if (s == 10 || s == 11) {
              res.ztlist[key].showType = 'success'
            } else {
              res.ztlist[key].showType = 'info'
            }
          }
          let hisIndex = this.historyData.indexOf(this.logisticsNumber)
          if (hisIndex != -1) {
            this.historyData.splice(hisIndex, 1)
            this.historyData.unshift(this.logisticsNumber)
          } else {
            if (this.historyData.length >= 6) {
              this.historyData.splice(this.historyData.length - 1, 1)
            }
            this.historyData.unshift(this.logisticsNumber)
          }
          this.setHistoryData(this.historyData)
        } else {
          this.$message.error('此单号找不到匹配的物流信息，请确认是本司的物流单号。')
          this.logisticsState = []
        }
      }
      this.fullscreenLoading = false
    },
    //   --------- 设置历史记录---------
    setHistoryData () {
      localStorage.setItem('ty_wlnum_history', JSON.stringify(this.historyData));
    },
    //   --------- 获取历史记录---------
    getHistoryData () {
      let a = localStorage.getItem('ty_wlnum_history')
      this.historyData = JSON.parse(a) || [];
    },
    //   --------- 获取轮播图---------
    async getAdImage () {
      this.fullscreenLoading = true
      let res = await apiAdImage({

      })
      if (res.errno == 0) {
        this.adImage = res.list
      }
      this.fullscreenLoading = false
    },
    //   --------- 作为组件使用的时候,初始化---------
    initialize () {

    }
  },
  props: {
    not: {
      type: Boolean,
      default: false
    },
    wlnum: {
      type: String,
      default: ''
    }
  },
  created () {
    this.getAdImage()
    this.getHistoryData()
    if (this.wlnum) {
      this.logisticsNumber = this.wlnum
      this.getLogistics_info()
    }
  }
}
</script>

<style lang='scss'>
.LogisticsInfo {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-carousel {
    width: 100%;
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
  .other_view {
    width: 70%;
    height: 70px;
    margin-top: 20px;
    display: flex;
    .other_view_item {
      border: 0;
      border-radius: 8px;
      flex: 1;
      margin-right: 10px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      i {
        font-size: 18px;
        padding-right: 4px;
        font-weight: 700;
      }
    }
    .el-button:hover {
      background-color: #4c90fd;
      color: #fff;
    }

    .other_view_item:last-child {
      margin-right: 0;
    }
  }
  .search_view {
    width: 70%;
    height: 100px;
    background-color: #fff;
    margin-top: -30px;
    position: relative;
    z-index: 200;
    box-shadow: 0px 3px 19px 0px rgb(0 0 0 / 21%);
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
      width: 7px;
      height: 4px;
      background-color: #e2e2e27c;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #e2e2e27c;
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #e2e2e27c;
    }
    .history_show {
      margin-top: 14px;
      width: 100%;
      font-size: 12px;
      display: flex;
      color: #777;
      display: flex;
      justify-content: space-between;
      //   align-items: center;
      .history_show_record {
        display: flex;
        overflow: auto;
      }
      .history_show_btn {
        min-width: 80px;
        text-align: right;
      }
      .history_title {
        min-width: 52px;
        margin-right: 20px;
        display: flex;
        align-items: center;
      }
      .el-tag {
        cursor: pointer;
        transition: all 0.3s;
        margin-right: 10px;
      }
      .el-tag:hover {
        // cursor: pointer;
        border-color: #409eff;
      }
    }
    .search_view_top {
      display: flex;
      .el-input__prefix {
        color: #777;
      }
      .el-input {
        margin-right: 20px;

        input {
          border: 0;
          background-color: #f1f1f1;
        }
        input::-webkit-input-placeholder {
          color: #777;
        }
        input::-moz-input-placeholder {
          color: #777;
        }
        input::-ms-input-placeholder {
          color: #777;
        }
      }
    }
  }
  .logistics_info {
    width: 70%;
    height: 100px;
    // background-color: pink;
    margin-top: 40px;
  }
}
</style>